import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container page-container" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-10" }
const _hoisted_4 = { class: "font-lead" }
const _hoisted_5 = { class: "col-md-2 align-text-right" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-md-12" }
const _hoisted_8 = {
  class: "table table--borderless table--responsive-headers",
  id: "metadata-table"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("th", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Handlinger")
], -1)
const _hoisted_10 = ["id"]
const _hoisted_11 = ["data-title"]
const _hoisted_12 = ["data-title"]
const _hoisted_13 = ["data-title"]
const _hoisted_14 = ["data-title"]
const _hoisted_15 = ["data-title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KlarTekst = _resolveComponent("KlarTekst")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", null, [
          _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.produktgruppe.overskrift' }, null, 8, ["tekstNoegle"])
        ]),
        _createElementVNode("p", _hoisted_4, [
          _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.produktgruppe.beskrivelse' }, null, 8, ["tekstNoegle"])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_router_link, {
          to: "/metadata/ny",
          class: "button button-secondary",
          id: "add-new"
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, [
              _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.produktgruppe.opret-ny' }, null, 8, ["tekstNoegle"])
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("table", _hoisted_8, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, _toDisplayString(_ctx.headerNavn), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.headerUnderNavn), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.headerVersion), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.headerValiditet), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.headerStatus), 1),
              _hoisted_9
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productGroups, (p) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: p.id,
                id: p.id
              }, [
                _createElementVNode("td", { "data-title": _ctx.headerNavn }, _toDisplayString(p.product_group_name), 9, _hoisted_11),
                _createElementVNode("td", {
                  "data-title": _ctx.headerUnderNavn,
                  style: {"word-wrap":"break-word","max-width":"200px"}
                }, _toDisplayString(p.product_subgroup_name), 9, _hoisted_12),
                _createElementVNode("td", { "data-title": _ctx.headerVersion }, _toDisplayString(p.version), 9, _hoisted_13),
                _createElementVNode("td", { "data-title": _ctx.headerValiditet }, _toDisplayString(_ctx.formatPeriod(p.start_date, p.end_date)), 9, _hoisted_14),
                _createElementVNode("td", { "data-title": _ctx.headerStatus }, _toDisplayString(p.display_status), 9, _hoisted_15),
                _createElementVNode("td", null, [
                  _createVNode(_component_router_link, {
                    to: '/metadata/' + p.id
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_KlarTekst, { tekstNoegle: 'tco.produktgruppe.rediger' }, null, 8, ["tekstNoegle"])
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ])
              ], 8, _hoisted_10))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}